<span class="ap-submit" data-testid="button">
    @if (isLoading()) {
        {{ loadingText() }}
        <span class="ap-submit__element ap-submit__element--first">.</span>
        <span class="ap-submit__element ap-submit__element--second">.</span>
        <span class="ap-submit__element ap-submit__element--third">.</span>
    } @else {
        <span data-testid="enabled-button">{{ submitText() }}</span>
    }
</span>
